import { Main, ViewButton } from 'components/ActionStyles/ActionStyles'
import React from 'react'
import { useNavigate } from 'react-router'

const DriveActonInfo = ({ drive, disabled }) => {
  const navigate = useNavigate()
  const handleDriveInfo = () => {
    navigate(`/expcandidatedrive/${drive?.id}`)
  }
  return (
    <Main>
      <ViewButton
        disabled={disabled}
        onClick={handleDriveInfo}
        height="32px"
        text={'View'}
      />
    </Main>
  )
}

export default DriveActonInfo
